/**
 * 批量编辑手机号弹层
 * 对应原 Vue 项目 phoneModal.vue
 *
 * 仅是 antd Modal 包裹 EditPhoneTable，用于已生成二维码后批量编辑执行人。
 */
import React from "react";
import { Modal } from "antd";
import EditPhoneTable from "./EditPhoneTable";

const PhoneModal = ({
  phoneModalViable,
  isCreatedQrcode,
  qrData,
  record,
  onHandlePhoneModal,
  onChangeQRCodeData,
}) => {
  return (
    <Modal
      title="批量编辑手机号"
      visible={phoneModalViable}
      width={800}
      destroyOnClose
      maskClosable={false}
      footer={null}
      onCancel={onHandlePhoneModal}
    >
      <EditPhoneTable
        qrData={qrData}
        isCreatedQrcode={isCreatedQrcode}
        record={record}
        // 已生成二维码后，点"生成二维码"=重新生成
        onCreateQRCode={onChangeQRCodeData}
        onChangeQRCodeData={onChangeQRCodeData}
        onHandlePhoneModal={onHandlePhoneModal}
        onShowLogs={() => {}}
      />
    </Modal>
  );
};

export default PhoneModal;
